<template>
    <div class="star-rating-input d-inline-flex align-center">
        <Vue3StarRatings
            :model-value="modelValue"
            :number-of-stars="5"
            :star-size="starSize"
            :star-color="starColor"
            :inactive-color="inactiveColor"
            :disable-click="false"
            @update:model-value="onUpdate"
        />
    </div>
</template>

<script>
/**
 * Interactive 1–5 star selection for API payloads (integers only).
 * vue3-star-ratings allows sub-star clicks; we snap to nearest integer in [1, 5], or 0 when unset.
 */
export default {
    name: "StarRatingInput",
    props: {
        modelValue: { type: Number, default: 0 },
        starSize: { type: Number, default: 20 },
        starColor: { type: String, default: "#ff9800" },
        inactiveColor: { type: String, default: "#9e9e9e" },
    },
    emits: ["update:modelValue"],
    methods: {
        onUpdate(raw) {
            const n = Number(raw);
            if (Number.isNaN(n) || n <= 0) {
                this.$emit("update:modelValue", 0);
                return;
            }
            const rounded = Math.min(5, Math.max(1, Math.round(n)));
            this.$emit("update:modelValue", rounded);
        },
    },
};
</script>

<style scoped>
.star-rating-input {
    flex-shrink: 0;
}
</style>
